// App.js
import './App.css';
import ComingSoon from './pages/Auth/comingSoon';
import ResetPassword from './pages/Auth/resetpassword';
import Signin from "./pages/Auth/signin";
import Signup from "./pages/Auth/signup";
import VerifyEmail from "./pages/Auth/verifyEmail";
import Homepage from './pages/Homepage/index';
import User from './pages/User/index';
import CreateUser from './pages/User/createUserContainer';
import ViewDetails from './pages/User/viewDetails';
import Event from './pages/Event/index';
import EventContainer from './pages/Event/eventContainerForm';
import ValueTag from './pages/ValueTags/index';
import ValueTagDetails from './pages/ValueTags/valueTagDetails';
import Department from './pages/Department/index';
import DepartmentDetails from './pages/Department/details';
import JobGrade from './pages/JobGrade/index';
import JobGradeDetails from './pages/JobGrade/details';
import EarnedPoint from './pages/Point/index';
import DistributePoint from './pages/Point/listingDistribute'
import EmployeeList from './pages/Point/details';
import Summary from './pages/Summary/index';
import CreateEvent from './pages/Event/addEvent';
import Mission from './pages/Mission/index';
import MissionContainer from './pages/Mission/missionContainerForm';
import Campaign from './pages/Campaign/index';
import CampaignContainer from './pages/Campaign/campaignContainerForm';
import Terms from './pages/Terms/index';
import Teams from './pages/Team/index';
import Policy from './pages/Policy/index';
import GlobalSetting from './pages/GlobalSetting';
import TeamDetails from './pages/Team/details';

import { Route, BrowserRouter, Routes } from 'react-router-dom';
import ProtectedRoute from './pages/Auth/protectedRoute';
import PrivateRoutes from './utils/privateRoutes';
import ForgotPassword from './pages/Auth/forgotpassword';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/verifyEmail" element={<VerifyEmail />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/tnc" element={<Terms />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="*" element={<ComingSoon />} />

        {/* Private Routes (Protected) */}
        <Route
          element={
            <ProtectedRoute>
              <PrivateRoutes />
            </ProtectedRoute>
          }
        >
          <Route path="/summary" element={<Summary />} />
          <Route path="/" element={<Homepage />} />
          <Route path="/user" element={<User />} />
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/view-user/:id" element={<CreateUser />} />
          <Route path="/view-details/:id" element={<ViewDetails />} />
          <Route path="/event" element={<Event />} />
          <Route path="/view-event/:id" element={<EventContainer />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/view-mission/:id" element={<MissionContainer />} />
          <Route path="/campaign" element={<Campaign />} />
          <Route path="/view-campaign/:id" element={<CampaignContainer />} />
          <Route path="/department" element={<Department />} />
          <Route path="/view-department/:id" element={<DepartmentDetails />} />
          <Route path="/create-department" element={<DepartmentDetails />} />
          <Route path="/job-grade" element={<JobGrade />} />
          <Route path="/view-job/:id" element={<JobGradeDetails />} />
          <Route path="/create-job" element={<JobGradeDetails />} />
          <Route path="/earn-point" element={<EarnedPoint />} />
          <Route path="/distribute-point" element={<DistributePoint />} />
          <Route path="/view-employee/:id" element={<EmployeeList />} />
          <Route path="/value-tag" element={<ValueTag />} />
          <Route path="/create-valuetag" element={<ValueTagDetails />} />
          <Route path="/edit-valuetag/:id" element={<ValueTagDetails />} />
          <Route path="/view-valuetag/:id" element={<ValueTagDetails />} />
          <Route path="/account" element={<GlobalSetting />} />
          <Route path="/team" element={<Teams />} />
          <Route path="/view-team/:id" element={<TeamDetails />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
